import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { CPFValidator } from '../../shared/validators/cpf.validator';

import { UserService } from './../../shared/services/user.service';

@Component({
  selector: 'app-register-layout',
  templateUrl: './register-layout.component.html',
  styleUrls: ['./register-layout.component.scss']
})
export class RegisterLayoutComponent implements OnInit {
  private readonly emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  public registerForm: FormGroup;
  public submittingForm: boolean = false;
  public returnMessage: string;
  public messagesErrors: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  public onSubmit() {
    this.submittingForm = true; 
    this.returnMessage = null;
    this.messagesErrors = [];
            
    this.userService.register(this.registerForm.value).subscribe(data => {      
      this.submittingForm = false;
      this.returnMessage = data.message;      
    },(error) => {
      this.messagesErrors = error.errors;
      this.submittingForm = false;
    });
  }
  

  // METHODS PRIVATE
  private buildForm() {
    this.registerForm = this.formBuilder.group({
      name: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        Validators.minLength(3), 
        Validators.maxLength(255)        
      ]),
      email: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        Validators.minLength(3), 
        Validators.maxLength(60),
        Validators.pattern(this.emailPattern)
      ]),
      confirmEmail: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        Validators.minLength(3),
        Validators.maxLength(60),
        Validators.pattern(this.emailPattern)
      ]),
      phone: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        Validators.minLength(11), 
        Validators.maxLength(11)
      ]),
      birthday: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        Validators.minLength(8), 
        Validators.maxLength(10)
      ]),
      nameMother: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        Validators.minLength(3), 
        Validators.maxLength(255)
      ]),
      cpf: this.formBuilder.control({ value: '', disabled: false }, [
        Validators.required, 
        CPFValidator
      ])
    }, {validator: this.matchingEmailsValidator });
  }

  private matchingEmailsValidator(control: AbstractControl) {    
    let email = control.get('email').value;
    let confirmEmail = control.get('confirmEmail').value;
    if (email != confirmEmail) {
      control.get('confirmEmail').setErrors({ ConfirmEmail: true });
    }
    else {
      return null;
    }
}
}
